import BarekamButton from "../../button";
import React from "react";
import {DialogProps, DialogTitle, Divider,} from "@mui/material";
import {BarekamDialog} from "../standard-dialog/styled";
import {Message, MessageSections} from "../../message/message";

export const FilterDialog = ({children, onClose, ...props}: FilterDialogProps) => {
    return (
        <BarekamDialog {...props} fullScreen>
            <DialogTitle display={'flex'} justifyContent={'space-between'}>
                <Message messageKey={'filter'} sectionId={MessageSections.ORDERS}/>

                <BarekamButton type={"order-popup-close"} onClick={() => onClose()}/>
            </DialogTitle>

            <Divider style={{width:'100%'}}/>

            {children}
        </BarekamDialog>
    )
}

interface FilterDialogProps extends DialogProps {
    onClose: () => void,
}
